export default __webpack_public_path__ + "27bba3489c4fb545ca2e9f0e4499eed5.png";